<template>
    <div>
        <v-toolbar
                :dense="true"
                :flat="true"
                color="transparent"
        >
            <v-spacer></v-spacer>
            <v-tooltip right bottom>
                <template v-slot:activator="{ on }">
                    <v-btn icon @click="visibleHiddenGroups = !visibleHiddenGroups" v-on="on">
                        <v-icon :color="visibleHiddenGroups ? 'success' : ''">remove_red_eye</v-icon>
                    </v-btn>
                </template>
                <span class="caption">Показать скрытые списки ({{countHiddenMessagesLists}})</span>
            </v-tooltip>
        </v-toolbar>
        <v-container ma-0 pa-0 px-4 class="container-with-horizontal-scroll" fluid>
                <v-row style="flex-wrap: nowrap">
                    <v-col
                            cols="10" xs="8" sm="6" md="3"
                            class="pa-1 ma-0"
                            v-for="variableList in scenarios.variablesLists"
                            :key="variableList.id"
                            v-show="variableList.visible === 1 || visibleHiddenGroups"
                    >
                            <v-card
                                    class="d-flex flex-column"
                                    :color="variableList.visible === 1 ? 'blue-grey lighten-5' : 'blue-grey lighten-3'"
                            >
                                <v-card-title class="ml-2 pa-1">
                                    <v-list-item-title>
                                        <v-row>
                                            <v-col cols="10" class="pl-4 pa-0">
                                                <span style="cursor: pointer;"
                                                      class="bold subtitle-1"
                                                      @click="editVariablesList(variableList.id)">{{variableList.title}}</span>
                                            </v-col>
                                            <v-col cols="2" class="pa-0 ma-0" v-if="variableList.deleted === 0">
                                                <v-icon @click="deleteMessageList(variableList.id)" small>delete</v-icon>
                                            </v-col>
                                        </v-row>
                                    </v-list-item-title>
                                </v-card-title>
                                <div v-bind:style="[{height: (windowHeight - (scenarios.variablesLists.length > 3 ? 230 : 215)) + 'px'},{display: 'flex'},{'flex-direction': 'column'}]">
                                    <div class="content">
                                        <draggable
                                                v-model="variableSortedInList[variableList.id]"
                                                class="v-tabs__container"
                                                v-bind="{group:'messageLists'}"
                                                @start="isDragging=true" @end="isDragging=false"
                                                :move="checkMove"
                                                :id="'message_list_id_' + variableList.id"
                                        >
                                            <v-card-text class="pa-0 ma-0"
                                                         v-for="variable in variableSortedInList[variableList.id]"
                                                         :key="variable.id"
                                            >
                                                    <variable-card
                                                            :model="variable"
                                                            @editModel="editVariable({ variableId: variable.id, variablesListId: variableList.id })"
                                                            @removeModel="removeMessage({ variableId: variable.id, variablesListId: variableList.id })"
                                                    ></variable-card>
                                            </v-card-text>
                                        </draggable>
                                    </div>
                                </div>
                                <v-card-actions class="ma-0 pa-0">
                                    <v-btn
                                            class="caption"
                                            block
                                            color="primary"
                                            text
                                            dark
                                            @click="createMessage({ variablesListId: variableList.id})"
                                    >Создать сообщение</v-btn>
                                </v-card-actions>
                            </v-card>
                    </v-col>
                    <v-col cols="3">
                        <variables-list-form
                                :variablesListId="variablesListId"
                                :dialog="dialogVariablesList"
                                @close="dialogVariablesList = false"
                                @addNewMessagesList="addNewMessagesList"
                        ></variables-list-form>
                    </v-col>
                </v-row>
        </v-container>
        <dialog-confirmation ref="confirm" :dialogParams="dialogParams"></dialog-confirmation>
        <v-snackbar
                v-model="snackbar"
                bottom
                :color="paramsSnackbar.color"
                right
        >
            {{paramsSnackbar.text}}
            <v-btn
                    dark
                    text
                    @click="snackbar = false"
            >
                Закрыть
            </v-btn>
        </v-snackbar>
        <variables-form
                :editVariableId="editVariableId"
                :variablesListId="variablesListId"
                :dialog="dialog"
                @close="dialog = false"
                @addVariablesToVariablesList="addVariablesToVariablesList"
                @updateVariable="updateVariable"
        ></variables-form>
    </div>
</template>

<script>
import VariablesForm from '../../components/bot/scenarios/forms/VariablesForm'
import VariablesListForm from '../../components/bot/scenarios/forms/VariablesListForm'
import VariableCard from '../../components/bot/scenarios/cards/VariableCard'
import DialogConfirmation from '../../components/dialogs/DialogConfirmation'

import { mapGetters, mapState } from 'vuex'
import draggable from 'vuedraggable'

export default {
    name: 'Index',
    components: {
        draggable,
        VariablesListForm,
        DialogConfirmation,
        VariablesForm,
        VariableCard
    },
    data() {
        return {
            paramsSnackbar: {
                color: 'success',
                text: 'Операция прошла успешно!'
            },
            snackbar: false,
            dialog: false,
            dialogVariablesList: false,
            variablesListId: null,
            editVariableId: null,
            dialogParams: {},
            isDragging: false,
            variableSortedInList: {},
            unsortedVariables: [],
            changeMessagesList: null,
            visibleHiddenGroups: false,
            countHiddenMessagesLists: 0,
            windowHeight: 0
        }
    },
    watch: {
        dialog() {
            if (this.dialog === false) {
                this.editVariableId = null
                this.variablesListId = null
            }
        },
        dialogVariablesList(value) {
            if (value === false) {
                this.variablesListId = null
                this.countHiddenMessagesLists = this.messageLists.filter(model => model.visible === 0).length
            }
        },
        isDragging() {
            this.$nextTick(() => {
                if (this.changeMessagesList != null) {
                    this.changeMessagesList.forEach((item) => {
                        this.saveChangedMessageList(item)
                    })
                    this.changeMessagesList = null
                }
            })
        },
        allLoaded(value) {
            if (value) {
                this.loadVariablesToLists()
            }
        },
        botId(value) {
            this.$store.commit('scenarios/allLoadedChangeValue', false)
            this.$store.dispatch('scenarios/changeBotIdModelDefault', value)
            this.$store.dispatch('scenarios/variablesAll', value)
        },
        pageName() {
            this.allLoaded(true)
        },
        '$route.params': { // метод позволяет запускать функции после после возвращения на эту загруженную страницу
            handler: function() {
                this.loadVariablesToLists()
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        createMessage(payload) {
            this.variablesListId = payload.variablesListId
            this.editVariableId = null
            this.dialog = true
        },
        editVariable(payload) {
            this.variablesListId = payload.variablesListId
            this.editVariableId = payload.variableId
            this.dialog = true
        },
        checkMove(event) {
            if (event.draggedContext.element === undefined) {
                return false
            }
            let fromId = event.from.id
            fromId = fromId.replace('message_list_id_', '')
            let toId = event.to.id
            toId = toId.replace('message_list_id_', '')
            this.changeMessagesList = []
            if (fromId === toId ? +fromId !== 0 : true) {
                if (+fromId !== +toId && +fromId !== 0) {
                    this.changeMessagesList.push(+fromId)
                }
                if (+toId !== 0) {
                    this.changeMessagesList.push(+toId)
                }
            }
        },
        async removeMessage(payload) {
            this.$refs.confirm.open('Удаление сообщения', 'Вы действительно хотите удалить?',
                { color: 'red', agree: 'Подтверждаю', cancel: 'Отмена' })
                .then((confirm) => {
                    if (confirm === true) {
                        this.$store.dispatch('scenarios/variableDelete', payload.variableId).then(response => {
                            if (response.type === 'DeleteResult') {
                                let index = this.variableSortedInList[payload.variablesListId].findIndex(message => message.id === response.response.data.id)
                                this.variableSortedInList[payload.variablesListId].splice(index, 1)
                                this.paramsSnackbar.color = 'success'
                            } else {
                                this.paramsSnackbar.color = 'error'
                            }
                            this.paramsSnackbar.text = response.response.text
                            this.snackbar = true
                        })
                    }
                })
        },
        async deleteMessageList(id) {
            this.$refs.confirm.open('Удаление сообщения', 'Вы действительно хотите удалить?',
                { color: 'red', agree: 'Подтверждаю', cancel: 'Отмена' })
                .then((confirm) => {
                    if (confirm === true) {
                        this.$store.dispatch('messages/deleteMessageList', id)
                    }
                })
        },
        editVariablesList(id) {
            this.variablesListId = id
            this.dialogVariablesList = true
        },
        saveChangedMessageList(variablesListId) {
            let newModel = Object.assign({}, this.getVariablesListById(variablesListId))
            newModel.variables = []
            let unique = []
            for (let i = (this.variableSortedInList[variablesListId].length - 1); i >= 0; i--) {
                if (unique.indexOf(this.variableSortedInList[variablesListId][i].id) >= 0) { // если в списке уже есть сообщение с похожим id, значит нужно удалить его
                    this.variableSortedInList[variablesListId].splice(i, 1)
                } else {
                    unique.push(this.variableSortedInList[variablesListId][i].id)
                    newModel.variables.push(this.variableSortedInList[variablesListId][i].id)
                }
            }
            newModel.variables.reverse()
            this.$store.dispatch('scenarios/saveVariablesList', newModel).then(response => {
                this.paramsSnackbar.color = 'error'
                if (response.type === 'CreateResult' || response.type === 'UpdateResult') {
                    newModel = response.response.data
                    this.paramsSnackbar.color = 'success'
                }
                this.paramsSnackbar.text = response.response.text
                this.snackbar = true
            })
        },
        addVariablesToVariablesList(payload) {
            this.variableSortedInList[payload.variablesListId].push(payload.variable)
            this.saveChangedMessageList(payload.variablesListId)
        },
        updateVariable(payload) {
            let index = this.variableSortedInList[payload.variablesListId].findIndex(variableModel => variableModel.id === payload.variableModel.id)
            this.variableSortedInList[payload.variablesListId][index] = Object.assign({}, payload.variableModel)
        },
        addNewMessagesList(model) {
            this.$set(this.variableSortedInList, model.id, [])
        },
        loadVariablesToLists() {
            let unsortedVariables = this.variables.slice()
            this.variableSortedInList = {}
            this.variablesLists.forEach((item) => {
                if (!this.variableSortedInList.hasOwnProperty(item.id)) {
                    this.$set(this.variableSortedInList, item.id, [])
                }
                if (item.variables.length !== 0) {
                    item.variables.forEach((messageId) => {
                        let message = this.getVariableById(+messageId)
                        if (message) { this.variableSortedInList[item.id].push(message) }
                        let index = unsortedVariables.findIndex(message => message.id === +messageId)
                        unsortedVariables.splice(index, 1)
                    })
                }
            })
            unsortedVariables.forEach((message) => {
                this.variableSortedInList[this.unsortedVariablesListId].push(message)
            })
        },
        handleResize() {
            this.windowHeight = window.innerHeight
        }
    },
    created() {
        this.$store.dispatch('scenarios/changeBotIdModelDefault', this.$route.params['pathMatch'])
        this.$store.dispatch('keyboards/loadKeyboards', this.$route.params['pathMatch'])
        this.$store.dispatch('scenarios/variablesAll', this.$route.params['pathMatch'])
        this.$store.dispatch('scenarios/variablesListsAll', this.$route.params['pathMatch'])
        window.addEventListener('resize', this.handleResize)
        this.handleResize()
    },
    computed: {
        ...mapState([
            'scenarios'
        ]),
        ...mapGetters({
            variables: 'scenarios/variables',
            variablesLoaded: 'scenarios/variablesLoaded',
            variablesListsLoaded: 'scenarios/variablesListsLoaded',
            variablesLists: 'scenarios/variablesLists',
            getVariableById: 'scenarios/getVariableById',
            getVariablesListById: 'scenarios/getVariablesListById',
            unsortedVariablesListId: 'scenarios/unsortedVariablesListId'
        }),
        allLoaded() {
            return this.variablesLoaded && this.variablesListsLoaded
        },
        botId() {
            return +this.$route.params['pathMatch']
        }
    }
}
</script>

<style scoped lang="scss">
    ::-webkit-scrollbar {
        width: $width-scroll-panel;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: $light;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: $blue-active ;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: $blue-inactive;
    }
</style>
